<template>
  <div
    class="modal-mask"
    style="display: block"
    @click="$emit('modal-close')"
  >
    <div
      :id="elementId"
      :class="rootClasses"
      style="display: block"
    >
      <div
        :class="sizeClass"
        class="modal-dialog"
        role="document"
        @click.stop="handleModalClick"
      >
        <div :class="contentElementClasses">
          <slot
            name="header"
            class="modal-header"
          />
          <slot
            name="body"
            class="modal-body"
          />
          <slot
            name="footer"
            class="modal-footer"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const modalOpenClassName = 'modal-open'

export default {
  name: 'BootstrapModal',
  props: {
    elementId: { type: String, default: 'bootstrap-modal', required: false },
    size: { type: String, default: 'md', required: false },
    contentClasses: { type: Array, default: function () { return [] }, required: false },
    verticalCenter: { type: Boolean, default: false, required: false }
  },
  computed: {
    rootClasses () {
      const classes = ['modal', 'modal-mask']

      if (this.verticalCenter === true) {
        classes.push('modal--vertical-center')
      }

      return classes
    },
    sizeClass () {
      return `modal-${this.size}`
    },
    contentElementClasses () {
      let classes = ['modal-content']

      return classes.concat(this.contentClasses)
    }
  },
  mounted () {
    document.body.classList.add(modalOpenClassName)
  },
  destroyed () {
    document.body.classList.remove(modalOpenClassName)
  },
  methods: {
    handleModalClick () {
      // do nothing. just want to prevent the click from propagating to the modal mask and closing the modal
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  overflow: auto;

  &-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.2s ease;
  }

  &--vertical-center {
    overflow: auto;
    text-align: center;

    @media screen and (min-width: 768px) {
      &::before {
        display: inline-block;
        vertical-align: middle;
        content: " ";
        height: 100%;
      }
    }

    & .modal-dialog {
      display: inline-block;
      text-align: left;
      vertical-align: middle;
    }
  }

  &__content {
    &--bg-transparent {
      background-color: transparent !important;
    }

    &--square-corners {
      border-color: transparent;
      border-radius: 0 !important;
      border-width: 0;
      box-shadow: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/BootstrapModal.vue